'use strict'

import Vue from 'vue'
import axios from 'axios'


const Axios = axios.create({
  timeout: 8000,
  responseType: 'json',
  baseURL: 'https://kclass.krcedu.com:82/kclass/',
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

Axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
Axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.status === 200) {
      return Promise.resolve(response)
    } else if (response.status !== 200) {
      return Promise.reject(response)
    }
  },
  function (error) {
    // Do something with response error
    if (error.response) {
      // if (error.response.status) {}
    }
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get () {
        return Axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin